import { Injectable } from "@angular/core";
import { Headers } from "@angular/http";
import { Observable } from "rxjs/Observable";
import { AdalHttp } from '../services/adal.http.service';
import "rxjs/add/operator/map";
import "rxjs/add/operator/do";
import "rxjs/add/operator/catch";

@Injectable()
export class TenantRetrieverService {
    constructor(private http: AdalHttp) {}

    getTenant() {
        var headers = new Headers();
        headers.append('Content-Type', 'application/json');
        let productUrl: string = "/api/tenants";
        return this.http.get(productUrl)
            .catch((error: any) => {
                return Observable.throw(error);                
            });
    }
}



/** WEBPACK FOOTER **
 ** ./app/services/tenant-Retriever.service.ts
 **/